<template>
  <div class="login">
    <div class="login__image"></div>
    <div class="login__form form">
      <div class="form__title">
        <img src="../assets/new_logo_resized.jpg" alt="logo" />
      </div>
      <div class="form__content">
        <div class="from__title">
          <h1>{{ $t('login') }}</h1>
        </div>
        <form @submit.prevent="makeLogin">
          <div class="content">
            <input id="email" type="text" class="base-input" placeholder="Username" v-model="username" @input="onChangeUsername" />
            <input id="password" type="password" class="base-input" placeholder="Password" v-model="password" />
          </div>
          <UiButton :name="$t('login')" type="submit" :loading="loading" :disabled="loading" />
          <div class="error" v-if="error">{{ error }}</div>
        </form>
      </div>
      <a href="http://support.acesalespos.com" target="_blank"> <UiBaseIcon iconName="mail" height="25" width="25" />{{ $t('contact_us') }} </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { AuthService } from '@/services/auth.service'
import UiBaseIcon from '@/components/icons/UiBaseIcon'
import StoreService from '@/services/store.service'
import { setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiButton from '@/components/UiButton'
import { platform } from '../constants/storePlatform'
import axios from 'axios'

export default {
  name: 'Login',
  components: {
    UiBaseIcon,
    UiButton
  },
  data () {
    return {
      username: '',
      password: '',
      error: '',
      loading: false,
      isInvalidTimeKidz: false
    }
  },
  created () {
    this.isInvalidTimeKidz = this.checkTimeKidz()
  },
  methods: {
    ...mapActions({
      getListOutletByStore: 'outlet/getListOutletByUser'
    }),
    async makeLogin () {
      if (this.isInvalidTimeKidz) {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.error = 'Your free account has expired since February 2, 2024. Contact ACE Sales POS for support.'
        }, 1500)
      } else {
        try {
          this.loading = true
          const user = await AuthService.makeLogin({
            username: this.username,
            password: this.password
          })
          this.error = ''
          await this.$store.dispatch('user/setCurrent', user)
          const token = localStorage.getItem('token')
          axios.defaults.headers.common.Authorization = `Bearer ${token}`
          this.getCurrenStore(user.data.id)
        } catch (error) {
          this.loading = false
          this.$store.commit('toast/NEW', { type: 'error', message: error ? error.message : '' })
          this.error = error && error.status === 401 ? 'User with same email not found' : error ? error.message : ''
        }
      }
    },
    async getCurrenStore (id) {
      try {
        const store = await StoreService.getCurrenStoreByUser(id)
        const storeID = store.data.length > 0 ? store.data[0].id : null
        const storeExternalID = store.data.length > 0 ? store.data[0].store_external_id : null
        const type = store.data.length > 0 ? store.data[0].type : null
        const storePlatform = store.data.length > 0 ? store.data[0].type : null
        let viewId = null
        if (platform.isMagentoPlatform(storePlatform)) {
          const taxConfig = await StoreService.getTaxConfigs(storeID)
          if (taxConfig && taxConfig.data && taxConfig.data.items) {
            viewId = platform.getStoreView(taxConfig.data.items)
          }
          if (!viewId || viewId.length < 1) {
            const views = await StoreService.getViews(storeID)
            if (views && views.data && views.data.items) {
              viewId = platform.getStoreView(views.data.items)
            }
          }
        }
        const storeConfig = await StoreService.getStoreConfig(storeID, viewId)
        setLocalStorage(localStorageKey.STORE_CONFIG, storeConfig.data)
        this.getListOutletByStore(storeID)
        this.$store.commit('user/SET_CURRENT_STORE', storeID)
        setLocalStorage(localStorageKey.STORE_ID, storeID)
        setLocalStorage(localStorageKey.STORE_EXTERNAL_ID, storeExternalID)
        setLocalStorage(localStorageKey.CURRENT_PLATFORM, type)
        this.loading = false
        window.location.href = window.location.origin
      } catch (error) {
        this.loading = false
        this.$store.commit('toast/NEW', { type: 'error', message: error ? error.message : '' })
      }
    },
    checkTimeKidz () {
      const today = new Date()
      const month = today.getMonth() + 1
      return month > 2 && this.username === 'kidzaniahn' && false
    },
    onChangeUsername () {
      this.isInvalidTimeKidz = this.checkTimeKidz()
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  width: 100%;

  &__image {
    min-height: 100vh;
    width: 60%;
    background-image: url('../assets/login-img_resized.jpg');
    background-size: cover;
    background-repeat: no-repeat;
  }

  &__form {
    width: 40%;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    &__title {
      margin-top: 10%;
      margin-bottom: 15%;
    }
    &__content {
      margin-bottom: 20px;
      text-align: center;
      width: 45%;
      h1 {
        color: $color-green-50;
        text-transform: none;
        font-size: 25px;
        margin-bottom: 20px;
      }
      input {
        margin-bottom: 20px;
      }
      button {
        width: 100%;
      }
      .error {
        color: $color-error;
        margin-top: 10px;
      }
    }
  }

  a {
    position: absolute;
    text-decoration: none;
    color: $color-black-50;
    bottom: 45px;
    display: flex;
    align-items: center;
    span {
      margin-right: 10px;
    }
  }
}
@include media_tablet {
  .login {
    &__image {
      width: 50%;
    }

    &__form {
      width: 50%;
    }
    .form {
      &__content {
        width: 85%;
      }
    }
  }
}
</style>
